<div class="wrapper">
  <div class="container custom-scroll">
    @if (content) {
      <app-content [content]="content" [showTitle]="true" [contentPostUrl]="contentPostUrl" />
    }
  </div>

  @if (application.blocked | async) {
    <div id="blocked-overlay">
      <!-- <mat-icon [tooltip]="'[BLOCKED-TEXT]'">block</mat-icon> -->
    </div>
  }

  @if (application.loading | async) {
    <div id="loading-overlay">
      <app-loader />
    </div>
  }
</div>
